<div class="hc-input-dropdown">
  <button type="button"
          [class]="containerClass"
          [id]="inputId"
          [disabled]="disabled"
          (click)="toggle()"
          [attr.aria-expanded]="isOpen"
          aria-haspopup="listbox">
    @if (selectedLabel) {
      <span class="hc-input__value">{{ selectedLabel }}</span>
    } @else {
      <span class="hc-input__placeholder">{{ placeholder }}</span>
    }
    <lucide-icon [name]="isOpen ? 'chevron-up' : 'chevron-down'" [size]="24" class="hc-input__icon hc-input__icon--right" aria-hidden="true"></lucide-icon>
  </button>

  @if (isOpen) {
    <ul class="hc-input-dropdown__menu" role="listbox">
      @for (option of options; track option.value) {
        <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
        <li class="hc-input-dropdown__option"
            [class.hc-input-dropdown__option--selected]="isSelected(option)"
            [class.hc-input-dropdown__option--has-description]="!!option.description"
            role="option"
            [attr.aria-selected]="isSelected(option)"
            (click)="select(option)">
          <span class="hc-input-dropdown__option-label">{{ option.label }}</span>
          @if (option.description) {
            <span class="hc-input-dropdown__option-description">{{ option.description }}</span>
          }
        </li>
      }
    </ul>
  }
</div>
